var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useErrorHandler } from './useErrorHandler';
import { MAFIA_CONFLICT_ERROR } from '../types/errors';
export const useAsyncExecAction = () => {
    const { errorHandler: innerErrorHandler } = useErrorHandler();
    const execAsyncAction = ({ action, errorHandler = null, final = null, log = true }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            yield action();
            return true;
        }
        catch (e) {
            const status = (_a = e.response) === null || _a === void 0 ? void 0 : _a.status;
            // 409 логируем как info, не error
            if (status === MAFIA_CONFLICT_ERROR) {
                console.info('State conflict (409):', (_b = e.response) === null || _b === void 0 ? void 0 : _b.data);
            }
            else if (log) {
                console.error(e.response);
            }
            // Вызываем errorHandler (теперь async)
            if (errorHandler) {
                yield errorHandler(e);
            }
            else {
                yield innerErrorHandler(e);
            }
            return false;
        }
        finally {
            yield (final === null || final === void 0 ? void 0 : final());
        }
    });
    return {
        execAsyncAction,
    };
};
